// Chart of Account stuff
export default {
    methods: {
        async refreshChartOfAccounts() {
            let now = new Date();
            let currentTime = now.getTime();
            this.waiting = true;
            if (await this.getProbooksResources(currentTime)) {
                this.createDialog({ "title": "Success", "body": 'Refreshed Chart of Accounts' , "buttonNo": false, "buttonYesLabel": "OK"  });
            } else {
                this.createDialog({ "title": "Error", "body": 'Please contact our support team.' , "buttonNo": false, "buttonYesLabel": "OK"  });
            }
            this.waiting = false;
        },
        async getProbooksResources(time) {
            // we need to reset when we update COA because we want to check whethere data is loaded successfully or not.
            let COAobject = { account : [], freeFields: [], series: [], locations: [], sets: [], time: time, isLoaded: false}
            // use '#' char because we want to distinguish whethere data in local storage is COA or not in local storage to remove when local storage is full.
            localStorage.setItem(entityId + '#', JSON.stringify(COAobject));
            try {
                // send accounts data to check whether can get data or not. if there is no data or error, will not be return 200 or 201.
                const responseAccounts = await this.oasisApi.get('probooks/accounts?postable=1&corporate=false');
                if (responseAccounts.status == 200 || responseAccounts.status == 201) {
                    const responseFreeFields = await this.oasisApi.get('probooks/freefields');
                    const responseSeries = await this.oasisApi.get('probooks/series');
                    const responseLocations = await this.oasisApi.get('probooks/locations');
                    const responseSets = await this.oasisApi.get('probooks/sets');
                    const responseProjects = await this.oasisApi.get('probooks/newprojects');

                    // to get all data.
                    this.probooksAccounts = responseAccounts.data.results || [];
                    this.probooksFreeFields = responseFreeFields.data.results || [];
                    this.probooksSeries = responseSeries.data.results || [];
                    this.probooksLocations = responseLocations.data.results || [];
                    this.probooksSets = responseSets.data.results || [];
                    this.probooksProjects = responseProjects.data.results || [];
                    COAobject = { accounts : this.probooksAccounts, freeFields: this.probooksFreeFields, series: this.probooksSeries, locations: this.probooksLocations, sets: this.probooksSets, projects: this.probooksProjects, time: time, isLoaded: true}
                    localStorage.setItem(entityId + '#', JSON.stringify(COAobject));
                    return true;
                } else {
                    COAobject = { account : [], freeFields: [], series: [], locations: [], sets: [], projects: [], time: time, isLoaded: true}
                    localStorage.setItem(entityId + '#', JSON.stringify(COAobject));
                    return false;
                }
            } catch (e) {
                // If local storage is full and can't save COA, will remove all COA and set current entity COA. (It's normally for admin user)
                // everything except Firefox (22, Firefox - 1014). test name field too, because code might not be present
                if (e.code === 22 || e.code === 1014 || e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
                    const keys = Object.keys(window.localStorage);
                    for(const key of keys) {
                        // remove legacy too.
                        if (key.includes("#") || key === 'entityInfo' || key === 'accounts' || key === 'freefields' || key === 'series' || key === 'locations' || key === 'sets') {
                            window.localStorage.removeItem(key);
                        }
                    }
                    localStorage.setItem(entityId + '#', JSON.stringify(COAobject));
                }
            }
        },

        async retrieveAllData(resource, field) {
            let results = [];
            if (resource.status == 200 || resource.status == 201) {
                results.push(...resource.data.results);
                if (resource.data.page_count > 1) {
                    for (let page=2; page<=resource.data.page_count; page++) {
                        let res;
                        if (field == 'accounts') res = await this.oasisApi.get('probooks/accounts?postable=1&page=' + page);
                        else res = await this.oasisApi.get('probooks/' + field + '?page=' + page);

                        if (res.status == 200 || res.status == 201) results.push(...res.data.results);
                    }
                }
            }
            return results;
        },

        // V2 is a copy of the existing fringCheck function, but with custom rules (fringeRules)
        // and the ability to check codes, buckets propay_ids, etc.
        // Assumes we have access to the assignment object, and if ProBooks is used,
        // that the selected_fringe_code element exists.
        async fringeCheckV2(selectedData, type='budget_code_regex', target='fringe_code', source='budget_code') {
            // if we got error case, this function will not be fired.
            const useProbooks = typeof this.enableProBooks !== undefined && this.enableProBooks;
            const coaRules = typeof this.coaRules !== undefined && this.coaRules.length;
            let val = ''

            // Using ProBooks autocomplete
            if (selectedData && selectedData.code) {
                val = selectedData.code;

            // Normal input element
            } else if (selectedData.target) {
                val = selectedData.target.value;
                
            // catchall
            } else if (selectedData) {
                // this case would be custom data instead of selection. (if we set mustMatch = false, we will get this case)
                val = selectedData;
            }

            // Try to use rules
            const coaHelper = val && coaRules && this.coaRuleHelper(val, type) ? this.coaRuleHelper(val, type) : null;

            // can use for fringe, series, etc., but for v1, use for fringe first
            const fringe = coaHelper && coaHelper.fringe_code ? coaHelper.fringe_code : (val ? val.substring(0, val.length-2) + '99' : '');
            // Validate if using ProBooks
            let validate = useProbooks ? this.probooksAccounts.findIndex((el) => { return el.code == fringe }) : true;
            if (validate == -1) {
                this.assignment[target] = '';
                this[`selected_${target}`] = '';
            } else if (!useProbooks && val.length < 4) {
                this.assignment[target] = '';
                this[`selected_${target}`] = '';
            } else {
                this.assignment[target] = fringe;
                this[`selected_${[target]}`] = fringe
            }

            // Set the source code here, e.g. budget_code
            this.assignment[source] = val;
            this.modified = true;

            // Loop to go over the rest of the coaHelper output besides fringe
            if (coaHelper) {
                const accountElements = [ 
                    { rule: 'series_code', field: 'series_code' },
                    { rule: 'location_code', field: 'location_code' },
                    { rule: 'set_code', field: 'set_code' },
                    { rule: 'ff1', field: 'free_field' },
                    { rule: 'ff2', field: 'free_field2' },
                    { rule: 'ff3', field: 'free_field3' },
                    { rule: 'ff4', field: 'free_field4' },
                ];
                for (const i in accountElements) {
                    const element = accountElements[i];
                    const field = element.field || 'fake';
                    const rule = element.rule || 'fake';
                    const newCode = coaHelper[rule] || null;
                    if (!newCode) continue;
                    this.assignment[field] = newCode;
                    this[`selected_${[field]}`] = newCode
                }
            }

            return;
        },

        coaRuleHelper(code=null, type='budget_code_regex') {
            if (!code || typeof this.coaRules === 'undefined' || !this.coaRules || !this.coaRules.length) {
                return null;
            }

            const result = {
                budget_code: '',
                fringe_code: '',
                hf_code: '',
                // episode_code: '',
                series_code: '',
                location_code: '',
                set_code: '',
                ff1: '',
                ff2: '',
                ff3: '',
                ff4: '',
            };

            this.coaRules.forEach((rule) => {
                if (code.match(rule[type])) {
                    // console.log(result.set_code, rule.customer_set);
                    if (rule.customer_budget_code) result.budget_code = rule.customer_budget_code || '';
                    if (rule.customer_fringe_code) result.fringe_code = rule.customer_fringe_code || '';
                    if (rule.customer_hf_code) result.hf_code = rule.customer_hf_code || '';
                    // if (rule.customer_episode) result.episode_code = rule.customer_episode || '';
                    if (rule.customer_series) result.series_code = rule.customer_series || '';
                    if (rule.customer_location) result.location_code = rule.customer_location || '';
                    if (rule.customer_set) result.set_code = rule.customer_set || '';
                    if (rule.customer_ff1) result.ff1 = rule.customer_ff1 || '';
                    if (rule.customer_ff2) result.ff2 = rule.customer_ff2 || '';
                    if (rule.customer_ff3) result.ff3 = rule.customer_ff3 || '';
                    if (rule.customer_ff4) result.ff4 = rule.customer_ff4 || '';
                }
            });

            return result;
        }
    },
  }
  